import { render, staticRenderFns } from "./QCPhotoFilter.vue?vue&type=template&id=4d5dc2c3"
import script from "./QCPhotoFilter.vue?vue&type=script&lang=js"
export * from "./QCPhotoFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports